import React from 'react';
// @ts-ignore
import styles from './UserWalletTransactionHistory.module.scss';
import FlatList from '../../../BaseModule/Components/FlatList/FlatList';
import UserWalletTransactionHistoryItem from './UserWalletTransactionHistoryItem';
import useFlatData from '../../../BaseModule/Hooks/useFlatData';
import useWalletTransactions from '../../Hook/useWalletTransactions';

interface Props {
	userId: string;
}


const UserWalletTransactionHistory: React.FC<Props> = ({userId}) => {
	const { getFlatWalletTransaction, getNextPage, data, isLoading, page, setPage } = useWalletTransactions(userId);
	const {flatData, hasMoreData, loadData} = useFlatData(
		getFlatWalletTransaction,
		{
			data: data?.orders?.data,
			totalPages: data?.orders?.meta?.totalPages,
			page: data?.orders?.meta?.page,
		},
		page,
		setPage,
	);
	return (
		<div className={styles.wrapper}>
			<FlatList data={flatData} isLoading={isLoading} renderItem={item => <UserWalletTransactionHistoryItem item={item} />} onRefresh={loadData} onLoadMore={getNextPage} hasMoreData={hasMoreData}/>
		</div>
	);
};

export default UserWalletTransactionHistory;

